import React from "react";
import { Helmet as ReactHelmet } from "react-helmet-async";
import { siteConfig } from "../../utils/site";

const Helmet = ({
  title,
  description,
  keywords,
  canonical,
  image = siteConfig.socialImage,
  type = "website",
  jsonLd,
  children,
}) => {
  const resolvedTitle = title || siteConfig.title;
  const resolvedDescription = description || siteConfig.description;
  const resolvedCanonical = canonical || siteConfig.url;
  const resolvedKeywords = keywords || siteConfig.defaultKeywords;

  return (
    <ReactHelmet>
      <title>{resolvedTitle}</title>
      <meta name="description" content={resolvedDescription} />
      <meta name="keywords" content={resolvedKeywords} />
      <meta property="og:title" content={resolvedTitle} />
      <meta property="og:description" content={resolvedDescription} />
      <meta property="og:type" content={type} />
      <meta property="og:url" content={resolvedCanonical} />
      <meta property="og:image" content={image} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={resolvedTitle} />
      <meta name="twitter:description" content={resolvedDescription} />
      <meta name="twitter:image" content={image} />
      <link rel="canonical" href={resolvedCanonical} />
      {Array.isArray(jsonLd)
        ? jsonLd.map((entry, index) => (
            <script key={index} type="application/ld+json">
              {JSON.stringify(entry)}
            </script>
          ))
        : jsonLd
          ? (
            <script type="application/ld+json">
              {JSON.stringify(jsonLd)}
            </script>
            )
          : null}
      {children}
    </ReactHelmet>
  );
};

export default Helmet;
